/**
 *
 * Asynchronously loads the component for UserManagementPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
